import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ProspectDetailView = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/prospect-management', { replace: true });
  }, [navigate]);
  return null;
};

export default ProspectDetailView;
